export default (uri) => {
  if(!uri || uri.indexOf('http') >= 0) {
    return uri;
  } else {
    return 'https://firebasestorage.googleapis.com/v0/b/diet-z.appspot.com/o/' + uri;
  }
}